export default __webpack_public_path__ + "static/media/login.d0c9fda8.svg";